<header *ngIf='user'></header>
<category-component *ngIf='user'></category-component>
<div  [ngClass]="{'fixed-header-height static-pages-header': true, 'mt-0': user ? false : true}">
    <h1>Contact Us</h1>
</div>
<div [ngClass]="{'grey-color static-pages side-space-wrapper contact-us': true, 'beforelogin': user? false : true}">
    <div class="container-fluid">
        <div class="row" *ngIf='user'>
            <div class="col-12">
                <ul class="breadcrumbs d-flex pt-3 pt-md-0">
                    <li>
                        <a routerLink="/" title="Home">Home</a>
                    </li>
                    <li>
                        <span> <img src="../../assets/images/seperator-arrow.svg" alt="seperator-arrow" /> </span>
                    </li>
                    <li>
                        Contact Us
                    </li>
                </ul>
                <div class="content-block">
                    <h2>{{contactDetail.heading}}</h2>
                    <p>{{contactDetail.mainContent}}</p>
                </div>
            </div>
        </div>
            <div class="row ml-0 mr-0">
                <div class="col-12 p-0 contact-form-heding content-block">
                    <a [routerLink]="['/users/login']"  class=" mt-md-0 mt-4 back-listing-btn back-cart" title="back">
                        <svg width="15px" height="16px" viewBox="0 0 15 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                            <!-- Generator: Sketch 61.2 (89653) - https://sketch.com -->
                            <title>Combined Shape</title>
                            <desc>Created with Sketch.</desc>
                            <g id="SCREENS" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                <g id="210209_shopboss_cart" transform="translate(-1719.000000, -1333.000000)" fill="#D9394C" fill-rule="nonzero">
                                    <path d="M1726.46967,1333.46967 L1727.53033,1334.53033 L1721.811,1340.24967 L1734,1340.25 L1734,1341.75 L1721.811,1341.74967 L1727.53033,1347.46967 L1726.46967,1348.53033 L1719.46967,1341.53033 C1719.2034,1341.26406 1719.1792,1340.8474 1719.39705,1340.55379 L1719.46967,1340.46967 L1726.46967,1333.46967 Z" id="Combined-Shape"></path>
                                </g>
                            </g>
                        </svg>
                        Back
                    </a>
                    <h2>{{contactDetail.heading}}</h2>
                    <p>{{contactDetail.mainContent}}</p>
                </div>
            </div>
            <div class="contact-wrapper row ml-0 mr-0">
            <div class="col-12 col-lg-6 p-0">
                <div class=" left-column form-box">
                    <form [formGroup]="contactUsForm" (ngSubmit)="contactUsSubmit()" autocomplete="off">
                        <div class="form-group">
                            <label>Your Name<sup>*</sup></label>
                            <input type="text" class="form-control" placeholder="E.g. Adam Smith" formControlName="name">
                            <div *ngIf="submitted && contactUsForm.controls.name.errors" class="error">
                                <div *ngIf="contactUsForm.controls.name.errors?.required"><img src="assets/images/error.svg" />
                                    Name is required</div>
                                <div *ngIf="contactUsForm.controls.name.errors?.maxlength"><img src="/assets/images/error.svg" /> Name not be greater then 30 characters</div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label>Email address <sup>*</sup></label>
                            <input type="email" class="form-control" placeholder="E.g. adamsmith@email.com" formControlName="email">
                            <div *ngIf="submitted && contactUsForm.controls.email.errors" class="error">
                                <div *ngIf="contactUsForm.controls.email.errors?.required"><img src="assets/images/error.svg" />
                                    Email is required</div>
                                <div *ngIf="contactUsForm.controls.email.errors?.email"><img src="assets/images/error.svg" />
                                    Email must be a valid email address</div>
                            </div>
                        </div>
                        <div class="form-group mb-0">
                            <label>Your Message <sup>*</sup></label>
                            <textarea class="form-control" placeholder="Type here.." rows="3" formControlName="message"></textarea>
                            <div *ngIf="submitted && contactUsForm.controls.message.errors" class="error">
                                <div *ngIf="contactUsForm.controls.message.errors?.required"><img src="assets/images/error.svg" />
                                    Message is required</div>
                                <div *ngIf="contactUsForm.controls.message.errors?.maxlength"><img src="/assets/images/error.svg" /> Message not be greater then 500 characters</div>
                            </div>
                        </div>
                        <button type="submit" class="btn primary-btn">Submit</button>
                    </form>
                </div>
            </div>
            <div class="col-12 col-lg-6 p-0">
                <div class="right-column">
                    <ul class="info">
                        <li>
                            <h3>{{bondsAddress.heading}}</h3>
                            <div class="address">
                                <img src="../../assets/images/location-white.svg" alt="mail">
                                <address>
                                   {{bondsAddress.address}}
                                </address>
                            </div>
                        </li>
                        <li>
                            <h3>{{bondsEnquiryDetails.heading}}</h3>
                            <div class="contact-box-info">
                                <img src="../../assets/images/telephone.svg" alt="telephone">
                                <a href="tel:{{bondsEnquiryDetails.phoneNumber}}" title="01623 446 001">{{bondsEnquiryDetails.phoneNumber}}</a>
                            </div>
                            <div  class="contact-box-info">
                                <img src="../../assets/images/calender.svg" alt="calender">
                                <span>{{bondsEnquiryDetails.timing}}</span>
                            </div>
                            <div  class="contact-box-info">
                                <img src="../../assets/images/mail.svg" alt="mail">
                                <a href="mailto:sales@worldofsweets.co.uk" title="sales@worldofsweets.co.uk">{{bondsEnquiryDetails.email}}</a>
                            </div>
                        </li>
                    </ul>
                    <p>{{contactDetail.secondaryContent}}</p>

                    <ul class="social-icon">
                        <li *ngFor="let data of socialMedia?.socialMediasWOS">
                            <a href="{{data?.url}}" title="{{data?.name}}" target=”_blank”>
                                <img  src="{{data?.image2.url}}" alt="{{data?.name}}">
                            </a>
                        </li>
                       
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
<footer *ngIf='user'></footer>
